import React, { memo, useMemo } from 'react';
import classnames from 'classnames';
import type { ReactNode } from 'react';
import styles from './index.module.scss';

export type SortMenuTitleProps = {
  title?: ReactNode;
  iconXLinkHref?: string;
  className?: string;
  iconClassName?: string;
};

const SortMenuTitle: React.FC<SortMenuTitleProps> = ({ title, iconXLinkHref, className, iconClassName }) => {
  const xlinkHref = useMemo(
    () => (iconXLinkHref ? (iconXLinkHref?.[0] === '#' ? iconXLinkHref : `#${iconXLinkHref}`) : ''),
    [iconXLinkHref]
  );
  return (
    <div className={classnames(styles.container, className)}>
      {xlinkHref && (
        <svg className={classnames(styles.icon, 'icon', iconClassName)} aria-hidden="true">
          <use xlinkHref={xlinkHref} />
        </svg>
      )}
      {title}
    </div>
  );
};

export default memo(SortMenuTitle);
